import React from 'react'
import { Link } from 'react-router-dom'
import { usePlays } from '../hooks/usePlays'
import { Play } from '../types'
import { NavBar } from '../components/NavBar'


const CATEGORY_LABELS: Record<Play['category'], string> = {
  tragedy: 'Tragedies',
  comedy: 'Comedies',
  history: 'Histories',
  romance: 'Romances',
}

const CATEGORY_ORDER: Play['category'][] = ['tragedy', 'comedy', 'history', 'romance']

export function PlaysPage() {
  const { plays, loading, error } = usePlays()

  if (loading) {
    return (
      <div className="min-h-screen bg-stone-900 text-stone-100">
        <NavBar />
        <p className="flex items-center justify-center py-20 text-stone-300">Loading plays…</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-stone-900 text-stone-100">
        <NavBar />
        <p className="flex items-center justify-center py-20 text-red-400">Failed to load plays: {error}</p>
      </div>
    )
  }

  const grouped = CATEGORY_ORDER.reduce<Record<Play['category'], Play[]>>(
    (acc, cat) => {
      acc[cat] = plays.filter((p) => p.category === cat)
      return acc
    },
    { tragedy: [], comedy: [], history: [], romance: [] }
  )

  return (
    <div className="min-h-screen bg-stone-900 text-stone-100">
      <NavBar />
      <div className="px-6 py-10">
      <div className="mx-auto max-w-5xl">
      <h1 className="mb-8 font-serif text-3xl font-semibold tracking-tight">
        The Shakespeare Canon
      </h1>

      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {CATEGORY_ORDER.map((cat) => (
          <section key={cat}>
            <h2 className="mb-3 border-b border-stone-700 pb-1 font-serif text-lg font-medium text-amber-400">
              {CATEGORY_LABELS[cat]}
            </h2>
            <ul className="space-y-1.5">
              {grouped[cat].map((play) => (
                <li key={play.id} className="text-sm text-stone-300">
                  <Link
                    to={`/plays/${play.id}`}
                    className="hover:text-amber-400 transition-colors"
                  >
                    {play.title}
                  </Link>
                  {play.co_author && (
                    <span className="ml-1.5 text-xs text-stone-500">
                      (w/ {play.co_author})
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      </div>
      </div>
    </div>
  )
}
